import React from "react";
import Credit from "./credits";
import Contact from "./contact";
import "./credits.css";

function ContactUs() {
  return (
    <div className="credit-contact w-100">
      <Credit />
    </div>
  );
}

export default ContactUs;
